import React from 'react';
import { SitemapProvider } from './src/utils/context/SitemapContext';
import { TranslatorProvider } from './src/utils/context/TranslatorContext';

export const wrapRootElement = ({ element }) => (
	<SitemapProvider>
		<TranslatorProvider>{element}</TranslatorProvider>
	</SitemapProvider>
);
